import { useGLTF } from '@react-three/drei'
import { type ObjectMap, useThree } from '@react-three/fiber'
import { type WebGLRenderer } from 'three'
import { DRACOLoader, type GLTF, type GLTFLoader, KTX2Loader } from 'three-stdlib'

const ktx2 = new KTX2Loader()
ktx2.setTranscoderPath('/basis/')

const draco = new DRACOLoader()
draco.setDecoderPath('/draco-gltf/')

const ktx2Renderers = new WeakSet<WebGLRenderer>()

const extender = (loader: GLTFLoader) => {
  loader.setKTX2Loader(ktx2)
  loader.setDRACOLoader(draco)
}

export function useCompressedGltf(path: string[]): (GLTF & ObjectMap)[]
export function useCompressedGltf(path: string): GLTF & ObjectMap
export function useCompressedGltf(
  path: string | string[],
): (GLTF & ObjectMap) | (GLTF & ObjectMap)[] {
  const gl = useThree(s => s.gl) as WebGLRenderer
  if (!ktx2Renderers.has(gl)) {
    ktx2.detectSupport(gl)
    ktx2Renderers.add(gl)
  }
  return useGLTF(path as string, true, true, extender)
}
